import { IError, ILoading } from '@types';
import {
    SET_DEFAULT_COUNTRY,
    SET_ERROR,
    SET_FORM_SUBMITTED,
    SET_LOADING,
    SET_SCROLL_TO_ERROR,
    StatusAction,
} from '@store/actions';

export interface IStatusState {
    defaultCountry: string;
    error: IError | null;
    formSubmitted: boolean;
    loading: ILoading;
    scrollToError: boolean;
}

export const initialState = {
    error: null,
    loading: {},
    formSubmitted: false,
    defaultCountry: config.defaultCountry[config.defaultPlatformCountry.toLowerCase() as keyof IConfigByPlatformConfig],
    scrollToError: false,
};

export const reducer = (state: IStatusState = initialState, action: StatusAction): IStatusState => {
    const { type, payload } = action;

    switch (type) {
        case SET_DEFAULT_COUNTRY: {
            const defaultCountry = payload as string;
            return { ...state, defaultCountry };
        }

        case SET_ERROR: {
            const error = payload as IError;
            return { ...state, error };
        }

        case SET_LOADING: {
            const loading = payload as ILoading;
            return { ...state, loading: { ...state.loading, ...loading } };
        }

        case SET_FORM_SUBMITTED: {
            const formSubmitted = payload as boolean;
            return { ...state, formSubmitted };
        }

        case SET_SCROLL_TO_ERROR: {
            const scrollToError = payload as boolean;
            return { ...state, scrollToError };
        }

        default:
            return state;
    }
};
